/**
 * Group type definitions
 * Shared between frontend and backend
 */

export enum GroupType {
  MANUAL = 'manual',
  /**
   * Auto-maintained group whose membership mirrors a UserRole. Created and
   * synced by Group.syncByRole() / the 001-create-role-based-groups migration.
   */
  ROLE_BASED = 'role_based',
}

export interface IGroup {
  _id: string;
  name: string;
  code: string;
  description?: string;
  type: GroupType;
  role?: string;
  members: string[]; // user ids
  membersCount: number;
  owner?:
    | string
    | {
        _id: string;
        firstName: string;
        lastName?: string;
        email?: string;
      };
  metadata?: Record<string, any>;
  isActive: boolean;
  isDefaultForRole?: boolean;
  isCoreTeam?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateGroupRequest {
  name: string;
  code?: string;
  description?: string;
  type: GroupType;
  role?: string;
  members?: string[];
  owner?: string;
  metadata?: Record<string, any>;
  isCoreTeam?: boolean;
}

export interface UpdateGroupRequest {
  name?: string;
  description?: string;
  owner?: string;
  metadata?: Record<string, any>;
  isCoreTeam?: boolean;
}

export interface GroupMembershipRequest {
  userIds: string[];
}

export interface GroupFilters {
  type?: GroupType;
  role?: string;
  isActive?: boolean;
  owner?: string;
  search?: string;
}

export interface GroupsListResponse {
  groups: IGroup[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface GroupMembersResponse {
  members: Array<{
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    department?: string;
    designation?: string;
    avatar?: string;
  }>;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}
